__turbopack_context__.v({
  "heading": "heading-module-scss-module__kemyla__heading",
  "heading-1": "heading-module-scss-module__kemyla__heading-1",
  "heading-2": "heading-module-scss-module__kemyla__heading-2",
  "heading-3": "heading-module-scss-module__kemyla__heading-3",
  "heading-4": "heading-module-scss-module__kemyla__heading-4",
  "responsive-image": "heading-module-scss-module__kemyla__responsive-image",
  "scroll-anchor": "heading-module-scss-module__kemyla__scroll-anchor",
  "skeleton": "heading-module-scss-module__kemyla__skeleton",
  "skeleton-1": "heading-module-scss-module__kemyla__skeleton-1",
  "skeleton-2": "heading-module-scss-module__kemyla__skeleton-2",
  "skeleton-3": "heading-module-scss-module__kemyla__skeleton-3",
  "text-align-large-center": "heading-module-scss-module__kemyla__text-align-large-center",
  "text-align-large-left": "heading-module-scss-module__kemyla__text-align-large-left",
  "text-align-large-right": "heading-module-scss-module__kemyla__text-align-large-right",
  "text-align-small-center": "heading-module-scss-module__kemyla__text-align-small-center",
  "text-align-small-left": "heading-module-scss-module__kemyla__text-align-small-left",
  "text-align-small-right": "heading-module-scss-module__kemyla__text-align-small-right",
});
